import { render, staticRenderFns } from "./OdontogramForm.vue?vue&type=template&id=6055050c&scoped=true"
import script from "./OdontogramForm.vue?vue&type=script&lang=js"
export * from "./OdontogramForm.vue?vue&type=script&lang=js"
import style0 from "./OdontogramForm.vue?vue&type=style&index=0&id=6055050c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6055050c",
  null
  
)

export default component.exports